/**
 * A filter that formats a boolean filter to a translated label (Yes/No).
 *
 * @todo Add other label types as needed
 * @type {ngFilter}
 */
function tmrBoolean($translate) {
  'ngInject'
  return boolean =>
    $translate.instant(boolean ? 'BOOLEANFILTER.YES' : 'BOOLEANFILTER.NO')
}

export const filter = ['tmrBoolean', tmrBoolean]
